<template>
  <b-row>
    <div class="col-12 col-sm-9">
      <section class="content">
        <b-card class="mb-3" :header="heading" no-body>
          <div class="card-body">
            <div class="form">
              <div class="form-row">
                <div class="col-md-12">
                  <b-form-group label="For Project:">
                    <b-form-select :options="projectsList" v-model="itemForm.projectId" />
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Name:">
                    <b-form-input v-model="itemForm.name" />
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group label="Description" :key="itemForm.content">
                    <markdwn-editor
                      ref="toastuiEditor"
                      id="toastuiEditor"
                      :initialValue="itemForm.content"
                      :options="editorOptions"
                      height="500px"
                      initialEditType="wysiwyg"
                      previewStyle="tab"
                    ></markdwn-editor>
                  </b-form-group>
                </div>
                <div class="col-md-12" v-if="!itemForm.id">
                    <b-form-group
                      label="Roles to Notify:"
                    >
                      <div class="border multicheckbox">
                        <label
                          v-for="itm in possibleRolesToPick"
                          :key="itm.value"
                          :for="'selItem-' + itm.value"
                          class="multicheckbox-item"
                        >
                          <input
                            :id="'selItem-' + itm.value"
                            v-model="itemForm.notifyRoles"
                            type="checkbox"
                            class="d-none"
                            :name="'selItem-' + itm.value"
                            :value="itm.value"
                          />
                          <span>{{ itm.text }}</span>
                        </label>
                      </div>
                    </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </section>
    </div>
    <aside class="col-12 col-sm-3">
      <b-card header="Actions">
        <button
          class="btn btn-block btn-primary"
          type="submit"
          @click="SaveForm"
        >
          Save Changes
        </button>
        <router-link
          class="mt-2 btn btn-block btn-danger"
          :to="{ name: 'Admin.Changelog.Index' }"
        >
          Cancel
        </router-link>
      </b-card>
    </aside>
  </b-row>
</template>

<script>
let refOfHttp = null;
let refOfEditor= false;
let addImageBlobHook = function(blob, callback, source) {
  if(refOfEditor) {
    let fileName = blob.name;
    let reader = new FileReader();
    reader.onload =  function(_a) {
      let formData = new FormData();
      formData.append('formFile', blob);
      formData.append('extension', fileName.split('.').pop());
      let headers = { 'Content-Type': 'multipart/form-data' };
      refOfHttp.post('/api/common/tickets/imageUpload', formData, { headers }).then((resp) => {
        let getUrl = window.location;
        let baseUrl = getUrl .protocol + '//' + getUrl.host + '/';
        let oldContent = refOfEditor.editor.getMarkdown();
        refOfEditor.editor.setMarkdown(oldContent + "\r\n "+ " \r\n" + '!['+fileName+']('+resp.data.url+')'+ "\r\n  "+ "  \r\n  ")
      });
    };
    reader.readAsDataURL(blob);
  }
  callback();
  return false;
};
import { Editor } from '@toast-ui/vue-editor';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'Admin.Changelog.Form',
  mixins: [crudMixinGen('docs/changelog'), myCommonDataMixin],
  components: {
    'markdwn-editor': Editor
  },
  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data: () => ({
    heading: 'Changelog Entry',
    editorOptions: {
      hooks: {
        addImageBlobHook: addImageBlobHook,
      },
      minHeight: '200px',
      language: 'en-US',
      useCommandShortcut: true,
      usageStatistics: true,
      hideModeSwitch: false,
      toolbarItems: [
        ['heading', 'bold', 'italic', 'strike'],
        ['hr', 'quote'],
        ['ul', 'ol', 'task', 'indent', 'outdent'],
        ['table', 'image', 'link'],
        ['code', 'codeblock'],
        ['scrollSync'],
      ],
      //plugins: [[chart, chartOptions], [codeSyntaxHighlight, { highlighter: Prism }], tableMergedCell, uml]
    },
    possibleRolesToPick: [
      {value: 'developer', text: 'Developer'},
      {value: 'superadmin', text: 'Superadmin'},
      {value: 'admin', text: 'Admin / Enterprise'},
      {value: 'manager', text: 'Logistics'},
      {value: 'warehouse-manager', text: 'Warehouse Manager'},
      {value: 'manufacturing-manager', text: 'Manufacturing'},
      {value: 'fourpl-manager', text: '4PL Partners'},
      {value: 'finance-manager', text: 'Finance'},

      {value: 'brand-user', text: 'Clients'},
    ]
  }),

  computed: {
  },

  watch: {
  },

  mounted() {
    this.ResetForm();
    if (this.id) {
      this.LoadItem(this.id).then((a) => {
        refOfEditor = this.$refs.toastuiEditor;
      })
    } else {
      this.readyToLoad = true;
      refOfEditor = this.$refs.toastuiEditor;
      refOfHttp = this.$http;
    }
  },

  methods: {
    SaveForm() {
      this.itemForm.content = this.$refs.toastuiEditor.invoke('getMarkdown');
      this.SaveItem()
      .then(resp => {
        if (resp.status) {
          if (resp.id) {
            this.$swal({ title: 'Article Was Saved.', icon: 'info' });
          } else {
            this.$swal({ title: 'New Article was added.', icon: 'success' });
          }
          this.$router.push({
            name: 'Admin.Changelog.Index'
          });
        } else {
          this.$swal({ title: resp.errorMessage, icon: 'error' });
        }
      })
      .catch(err => {
        console.error('saved po err', err);
      });
    }
  }
};
</script>
